import { Injectable } from '@angular/core';

import { ApiRequestService } from './api-request.service';
import { ApiPublicRequestService } from './api-public-request.service';
import { OrgInfoService } from './org-info.service';

import { throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable()
export class OrganizacaoService {

  constructor (
    private apiRequestService: ApiRequestService,
    private pubRequestservice: ApiPublicRequestService,    
  ) { }

  getDadosOrganizacao (url: string, pub: boolean) {    
    if (pub) {
      return this.getOrgPublico(url);
    } else {
      return this.getOrgPrivado(url);        
    }    
  }

  getOrgPublico (url: string) {
    return this.pubRequestservice.get (url);    
  }

  getOrgPrivado (url: string) {
    return this.apiRequestService.get (url);
  }


}
